import {Trans, useTranslation} from '@/translations/i18n.tsx'
import {Alert} from '@components/ui/alert'
import {Link} from 'react-router-dom'
import {routes} from '@utilities/constants/routes'

export const AddressAlert = ({isMarketConfiguration}: {isMarketConfiguration?: boolean}) => {
    const {t} = useTranslation()

    return (
        <Alert
            title={
                <Trans
                    i18nKey={
                        isMarketConfiguration
                            ? 'settings:address_alert_heading_market_configuration'
                            : 'settings:address_alert_heading'
                    }
                    components={{
                        Link: <Link className="underline cursor-pointer" to={routes.SETTINGS.handle.fullPath} />
                    }}
                />
            }
            description={t('settings:address_alert_description')}
            icon="error"
        />
    )
}
